import React from "react";

interface CoinLeftSVGProps {
  className?: string;
}

export default function CoinLeftSVG({ className }: CoinLeftSVGProps) {
  return (
    <svg
      className={className}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path
          fill="#EBBA16"
          d="M290.133,8.533h-68.267C132.326,8.533,59.733,119.33,59.733,256s72.593,247.467,162.133,247.467
          h68.267c89.54,0,102.4-110.797,102.4-247.467S379.674,8.533,290.133,8.533z"
        />
        <ellipse fill="#EBBA16" cx="221.867" cy="256" rx="162.133" ry="247.467" />
      </g>
      <ellipse fill="#FFBC00" cx="221.867" cy="256" rx="119.467" ry="204.8" />
      <path
        fill="#A37300"
        d="M384,256C384,119.33,311.407,8.533,221.867,8.533h68.267c89.54,0,162.133,110.797,162.133,247.467
        s-72.593,247.467-162.133,247.467h-68.267C311.407,503.467,384,392.67,384,256z"
      />
      <g>
        <path
          fill="#C99400"
          d="M320.572,452.267h68.267c-27.341,32.085-61.551,51.2-98.705,51.2h-68.267
          C259.021,503.467,293.231,484.352,320.572,452.267z"
        />
        <path
          fill="#C99400"
          d="M448.777,307.2c-4.267,30.976-12.339,59.81-23.424,85.333h-68.267
          c11.085-25.523,19.157-54.357,23.424-85.333H448.777z"
        />
        <path
          fill="#C99400"
          d="M425.344,119.467c11.085,25.523,19.157,54.357,23.424,85.333h-68.267
          c-4.267-30.976-12.339-59.81-23.424-85.333H425.344z"
        />
        <path
          fill="#C99400"
          d="M320.572,59.733c-27.341-32.085-61.551-51.2-98.705-51.2h68.267c37.154,0,71.364,19.115,98.705,51.2
          H320.572z"
        />
      </g>
      <g>
        <path
          fill="#000000"
          d="M221.867,512C127.761,512,51.2,397.158,51.2,256S127.761,0,221.867,0s170.667,114.842,170.667,256
          S315.972,512,221.867,512z M221.867,17.067c-84.693,0-153.6,107.187-153.6,238.933s68.907,238.933,153.6,238.933
          s153.6-107.187,153.6-238.933S306.56,17.067,221.867,17.067z"
        />
        <path
          fill="#000000"
          d="M221.867,469.333c-69.385,0-128-97.69-128-213.333s58.615-213.333,128-213.333
          s128,97.69,128,213.333S291.251,469.333,221.867,469.333z M221.867,59.733c-60.134,0-110.933,89.873-110.933,196.267
          s50.799,196.267,110.933,196.267S332.8,362.394,332.8,256S282.001,59.733,221.867,59.733z"
        />
        <path
          fill="#000000"
          d="M290.133,512h-68.267v-17.067c84.693,0,153.6-107.187,153.6-238.933S306.56,17.067,221.867,17.067V0
          h68.267C384.239,0,460.8,114.842,460.8,256S384.239,512,290.133,512z M283.153,494.933h6.98c84.693,0,153.6-107.187,153.6-238.933
          s-68.907-238.933-153.6-238.933h-6.98C347.076,54.084,392.533,147.226,392.533,256S347.076,457.916,283.153,494.933z"
        />
        <path
          fill="#000000"
          d="M290.133,512h-68.267v-17.067c33.451,0,65.331-16.666,92.211-48.196l2.551-3.004h90.692
          l-11.989,14.063C365.116,493.261,328.738,512,290.133,512z M283.58,494.933h6.554c28.066,0,55.023-11.733,78.857-34.133h-44.527
          C311.782,475.119,298.061,486.545,283.58,494.933z"
        />
        <path
          fill="#000000"
          d="M430.942,401.067h-86.869l5.18-11.93c11.034-25.404,18.705-53.359,22.801-83.098l1.016-7.373h85.495
          l-1.331,9.702c-4.309,31.275-12.407,60.74-24.055,87.569L430.942,401.067z M369.783,384h49.903
          c8.713-21.197,15.138-44.1,19.157-68.267h-50.978C384.068,339.746,378.001,362.624,369.783,384z"
        />
        <path
          fill="#000000"
          d="M458.564,213.333h-85.495l-1.016-7.364c-4.105-29.747-11.776-57.711-22.801-83.098l-5.188-11.938
          h86.878l2.227,5.137c11.648,26.82,19.738,56.277,24.055,87.569L458.564,213.333z M387.866,196.267h50.978
          c-4.019-24.175-10.445-47.078-19.157-68.267h-49.903C378.001,149.367,384.068,172.254,387.866,196.267z"
        />
        <path
          fill="#000000"
          d="M407.322,68.267h-90.692l-2.551-3.004c-26.871-31.531-58.761-48.196-92.211-48.196V0h68.267
          c38.605,0,74.982,18.739,105.199,54.204L407.322,68.267z M324.463,51.2h44.527c-23.825-22.4-50.79-34.133-78.857-34.133h-6.554
          C298.061,25.455,311.782,36.881,324.463,51.2z"
        />
      </g>
    </svg>
  );
}